
import $images from 'stores/images'

const __default__ = {
  props: {
    name: {
      type: String,
      default: ''
    },
    image_id: {
      type: String,
      default: undefined
    },
    width: {
      type: String,
      default: '4rem'
    },
    height: {
      type: String,
      default: '4rem'
    },
    fontSize: {
      type: String,
      default: '1.3rem'
    },
    showInfo: {
      type: Boolean,
      default: false
    },
    url: {
      type: String,
      default: undefined
    }
  },
  computed: {
    image(){
      return this.image_id ? $images.get(this.image_id) : {}
    },
    avatar_url(){
      return this.url || this.image?.url
    },
    loading(){
      return this.image.loading
    },
    initials () {
      if (!this.name) return
      const letters = this.name.split(' ').map(el => el[0])
      return letters.slice(0, 2).join('')
    }
  }
}

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "15711b09-fontSize": (_ctx.fontSize),
  "15711b09-width": (_ctx.width),
  "15711b09-height": (_ctx.height)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__